import {Product} from './Product';
import {File} from './File';
import {BaseObject} from './BaseObject';

export class ProductFile extends BaseObject {
    id: number;
    productId: number;
    file: File = new File();

    setFileContent = (data: string, filename: string) => {
        this.file.name = filename;
        this.file.base64 = data;
    }
}



// WEBPACK FOOTER //
// /app/src/model/Entities/ProductFile.ts